import { render } from "./aboutId.vue?vue&type=template&id=fe0acf2e&scoped=true"
import script from "./aboutId.vue?vue&type=script&lang=js"
export * from "./aboutId.vue?vue&type=script&lang=js"

import "./aboutId.vue?vue&type=style&index=0&id=fe0acf2e&scoped=true&lang=less"

import exportComponent from "D:\\STD7159\\源码管理\\前端\\stgd.oa.ows.inernetweb\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe0acf2e"]])

export default __exports__